import React from 'react';
import { useShop } from '../context/ShopContext'; // पाथ एडजस्ट करें
import { Trash2 } from 'lucide-react';

const CartPage: React.FC = () => {
  const { cartItems, removeItemFromCart } = useShop();

  const totalAmount = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  return (
    <div className="container mx-auto px-4 py-12 min-h-screen">
      <h1 className="text-3xl font-bold mb-8 text-center text-gray-800">Your Shopping Cart</h1>

      {cartItems.length === 0 ? (
        <div className="text-center p-10 border rounded-lg shadow-md bg-gray-50">
           <img
            src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
            alt="Empty Cart"
            className="w-40 mx-auto mb-6 opacity-90"
          />
          <p className="text-xl text-gray-600 mb-4">
            Your cart is empty. Start shopping now!
          </p>
          <a
            href="/"
            className="inline-block bg-amber-700 text-white px-6 py-2 rounded-full hover:bg-amber-800 transition-all duration-300"
          >
            Continue Shopping
          </a>
          
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          
          {/* Cart Items List */}
          <div className="lg:col-span-2 space-y-4">
            {cartItems.map((item) => (
              <div
                key={item.id}
                className="flex items-center p-4 border rounded-lg bg-white shadow-sm"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-20 h-20 object-cover rounded-md mr-4"
                />
                <div className="flex-grow">
                  <h2 className="text-lg font-semibold text-gray-800">{item.title}</h2>
                  <p className="text-sm text-gray-600">Price: ₹{item.price.toFixed(2)}</p>
                  <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
                  <p className="text-md font-bold text-amber-700">
                    Subtotal: ₹{(item.price * item.quantity).toFixed(2)}
                  </p>
                </div>
                <button
                  onClick={() => removeItemFromCart(item.id)}
                  className="p-2 text-red-500 hover:text-red-700 transition"
                  aria-label={`Remove ${item.title} from cart`}
                >
                  <Trash2 size={20} />
                </button>
              </div>
            ))}
          </div>

          {/* Cart Summary */}
          <div className="lg:col-span-1 p-6 border rounded-lg bg-white shadow-lg h-fit sticky top-28">
            <h2 className="text-xl font-bold mb-4 border-b pb-2 text-gray-800">Order Summary</h2>
            <div className="flex justify-between mb-2">
              <span className="text-gray-600">Items ({cartItems.length})</span>
              <span className="font-medium">₹{totalAmount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between mb-4">
              <span className="text-gray-600">Shipping</span>
              <span className="font-medium text-green-600">FREE</span>
            </div>
            <div className="flex justify-between border-t pt-4 text-xl font-bold text-amber-800">
              <span>Total Amount</span>
              <span>₹{totalAmount.toFixed(2)}</span>
            </div>
            <button
              className="w-full mt-6 bg-amber-700 text-white py-3 rounded-md hover:bg-amber-800 transition duration-300 font-semibold"
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;